import React, { useEffect, useState } from 'react';
import {
  getAvalaraSettings,
  createAvalaraSetting,
  updateAvalaraSetting,
  activateAvalaraSetting
} from '../service';
import { handleAPIError } from '../../../utils/apiUtils';

const useModuleState = () => {
  const [avalaraSettings, setAvalaraSettings] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAvalaraSettings = async () => {
    try {
      setLoading(true);
      const data = await getAvalaraSettings();
      setAvalaraSettings(data);
    } catch (error) {
      console.error('Failed to fetch avalara settings', error);
    } finally {
      setLoading(false);
    }
  };

  const addOrUpdate = async (setting) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      if (setting.id) {
        const updated = await updateAvalaraSetting(setting.id, setting);
        const updatedSettigs = avalaraSettings.map(c => (c.id === updated.id ? updated : c));
        setAvalaraSettings(updatedSettigs);
        response.success = true;
      } else {
        const created = await createAvalaraSetting(setting);
        const updatedSettigs = [...avalaraSettings, created];
        setAvalaraSettings(updatedSettigs);
        response.success = true;
      }
      fetchAvalaraSettings();
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update avalara setting', error);
    }
    return response;
  };
  
  const activateSetting = async (id) => {
    try {
      await activateAvalaraSetting(id);
      fetchAvalaraSettings();
    } catch (error) {
      console.error('Failed to activate the avalara settings', error);
    }
  }

  useEffect(() => {
    fetchAvalaraSettings();
  }, []);

  return { avalaraSettings, loading, addOrUpdate, activateSetting };
};

export default useModuleState;
